module.exports = __webpack_public_path__ + "static/media/flight-title-hokkaido.7fe78d9e.svg";